import config from "config";
import { ModalType } from "./PodcastProvider";
import { PodcastIconButton } from "./PodcastIconButton";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
// ui
import { Box, Flex, Image } from "@chakra-ui/react";
import { TwitterIcon, DiscordIcon } from "components/icons";
import { PodcastModal } from "./Modals";
import PodcastColorTypes from "types/podcastColorTypes";

export function PodcastNav() {
  return (
    <Box bg={getPodcastThemeToken(PodcastColorTypes.HeaderBackground)} color={getPodcastThemeToken(PodcastColorTypes.HeaderText)}>
      <Flex px={{ base: "16px", sm: "32px" }} py="12px" maxWidth="1512px" width="100%" mx="auto" justifyContent="space-between" alignItems="center" fontFamily="sora">
        <Image width="48px" height="48px" src={config?.logoUrl} />
        <Flex maxWidth="283px" width="100%" justifyContent="flex-end" alignItems="center">
          <Box display={{ base: "none", sm: "flex" }}>
            <PodcastIconButton name="twitterName" Icon={TwitterIcon} margin="27px" width="27px" height="22px" label="go-to-my-twitter-page" />
          </Box>
          <Box display={{ base: "none", sm: "flex" }}>
            <PodcastIconButton name="discordName" Icon={DiscordIcon} margin="27px" width="27px" height="22px" label="go-to-my-discord" />
          </Box>
          <PodcastModal modalButtonType={ModalType.Subscribe} />
        </Flex>
      </Flex>
    </Box>
  );
}
